import { Component, Input, ViewEncapsulation } from "@angular/core";
import { NewVersionCheckerService } from "./new-version-checker.service";

import { MessagesModule } from "primeng/messages";
import { PrimeTemplate } from "primeng/api";

@Component({
    selector: "app-new-version-checker",
    imports: [MessagesModule, PrimeTemplate],
    templateUrl: "./new-version-checker.component.html",
    styleUrl: "./new-version-checker.component.css"
})
export class NewVersionCheckerComponent {
  @Input() containerClasses: string;

  constructor(public newVersionCheckerService: NewVersionCheckerService) {}

  applyUpdate(): void {
    this.newVersionCheckerService.applyUpdate();
  }
}
